import router from "../../../router";
import axios from "axios";

export default {
    loadDocumentList({ commit, dispatch }, payload)
    {
        return new Promise((resolve, reject) => {
            let filter_fields = this.getters['documents/getDocumentFilterFields'];
            let main_filter = this.getters['documents/getDocumentMainFilter'];

            if (!payload['preloader_disable'] || payload['preloader_disable'] == false) {
                dispatch('pagePreloader/setPagePreloaderIsActive', true, {root: true});

                commit('setDocumentList', []);
            }

            if (!main_filter && router.currentRoute.query.main_filter) {
                main_filter = router.currentRoute.query.main_filter;

                commit('setDocumentFilterFieldMutation', {main_filter: router.currentRoute.query.main_filter});
            }

            if (!filter_fields.documentNumber && router.currentRoute.query.document_number) {
                filter_fields.documentNumber = router.currentRoute.query.document_number;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentNumber', field_value: router.currentRoute.query.document_number})
            }

            if (!filter_fields.documentTitle && router.currentRoute.query.document_title) {
                filter_fields.documentTitle = router.currentRoute.query.document_title;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentTitle', field_value: router.currentRoute.query.document_title})
            }

            if (!filter_fields.documentUserName && router.currentRoute.query.document_user_name) {
                filter_fields.documentUserName = router.currentRoute.query.document_user_name;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentUserName', field_value: router.currentRoute.query.document_user_name})
            }

            if (!filter_fields.documentHash && router.currentRoute.query.document_hash) {
                filter_fields.documentHash = router.currentRoute.query.document_hash;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentHash', field_value: router.currentRoute.query.document_hash})
            }

            if (!filter_fields.documentClientId && router.currentRoute.query.document_client_id) {
                filter_fields.documentClientId = router.currentRoute.query.document_client_id;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentClientId', field_value: router.currentRoute.query.document_client_id})
            }

            if (!filter_fields.documentCreatedAt && router.currentRoute.query.document_created_at) {
                filter_fields.documentCreatedAt = router.currentRoute.query.document_created_at;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentCreatedAt', field_value: router.currentRoute.query.document_created_at})
            }

            if (!filter_fields.documentStatus && router.currentRoute.query.document_status) {
                filter_fields.documentStatus = router.currentRoute.query.document_status;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentStatus', field_value: router.currentRoute.query.document_status})
            }

            if (!filter_fields.documentDeleted && router.currentRoute.query.document_deleted) {
                filter_fields.documentDeleted = router.currentRoute.query.document_deleted;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentDeleted', field_value: router.currentRoute.query.document_deleted})
            }

            if (!filter_fields.documentCompanyId && router.currentRoute.query.document_company_id) {
                filter_fields.documentCompanyId = router.currentRoute.query.document_company_id;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentCompanyId', field_value: router.currentRoute.query.document_company_id})
            }

            if (!filter_fields.documentUserRole && router.currentRoute.query.document_user_role) {
                filter_fields.documentUserRole = router.currentRoute.query.document_user_role;

                commit('setDocumentFilterFieldMutation', {field_name: 'documentUserRole', field_value: router.currentRoute.query.document_user_role})
            }

            if (!filter_fields.filterStartDate && router.currentRoute.query.filter_start_date) {
                filter_fields.filterStartDate = router.currentRoute.query.filter_start_date;

                commit('setDocumentFilterFieldMutation', {field_name: 'filterStartDate', field_value: router.currentRoute.query.filter_start_date})
            }

            if (!filter_fields.filterEndDate && router.currentRoute.query.filter_end_date) {
                filter_fields.filterEndDate = router.currentRoute.query.filter_end_date;

                commit('setDocumentFilterFieldMutation', {field_name: 'filterEndDate', field_value: router.currentRoute.query.filter_end_date})
            }

            payload['filter_fields'] = filter_fields;
            payload['main_filter'] = main_filter;

            axios.post('/api/document/client-list', payload).then((response) => {
                const result = response.data.data;

                if (response.data.data.code != 'ok')
                {
                    resolve({
                        error: true,
                        error_msg: 'Server response code not ok!',
                    });

                    return;
                }

                if (!response.data.data.result) {
                    resolve({
                        error: true,
                        error_msg: 'Result is empty!',
                    });

                    return;
                }

                dispatch('pagePreloader/setPagePreloaderIsActive', false, {root: true});

                commit('setDocumentList', response.data.data.result.documents);
                commit('setDocumentListCount', response.data.data.result.documents_count);

                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    },
    setDocumentFilterFields({ commit }, payload)
    {
        commit('setDocumentFilterFieldsMutation', payload);
    },
    deleteDocuments({ commit }, payload)
    {
        return new Promise((resolve, reject) => {
            axios.post('/api/document/delete-documents', {
                ids: payload
            }).then(response => {
                const result = response.data.data;

                if (response.data.data.result.success !== true) {
                    resolve(false);
                }

                commit('deleteDocumentsMutation', payload);

                resolve(true);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setDocumentModalOpen({commit}, payload)
    {
        commit('setDocumentModalOpenMutation', payload);
    },
    setDocumentIdAndDocumentIndexToModalForm({commit}, payload)
    {
        commit('setDocumentIdAndDocumentIndexToModalFormMutation', payload);
    },
    updateDocument({ commit }, payload)
    {
        commit('updateDocument', payload);
    },
    addDocumentToDocumentList({commit}, payload)
    {
        commit('addDocumentToDocumentList', payload);
    },
    updateDocumentExecutorStampDateTime({ commit }, payload)
    {
        commit('updateDocumentExecutorStampDateTime', payload);
    },
    updateDocumentShowSignBtn({ commit }, payload)
    {
        commit('updateDocumentShowSignBtn', payload);
    },
    updateDocumentSignatoriesCount({ commit }, payload)
    {
        commit('updateDocumentSignatoriesCount', payload);
    },
    setSignatoryModalOpen({commit}, payload)
    {
        commit('setSignatoryModalOpenMutation', payload);
    },
    setSignatoryList({ commit }, payload)
    {
        commit('setSignatoryList', payload);
    },
    updateSignatory({ commit }, payload)
    {
        commit('updateSignatory', payload);
    },
    addSignatoryToSignatoryList({ commit }, payload)
    {
        commit('addSignatoryToSignatoryList', payload);
    },
    setSignatoryIdAndSignatoryIndexToModalForm({commit}, payload)
    {
        commit('setSignatoryIdAndSignatoryIndexToModalFormMutation', payload);
    },
    plusDocumentSignatoriesCount({ commit }, payload)
    {
        commit('plusDocumentSignatoriesCount', payload);
    },
}
